import { render } from "./Electronic.vue?vue&type=template&id=65d0b176"
import script from "./Electronic.vue?vue&type=script&lang=js"
export * from "./Electronic.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__